import * as React from 'react';
import cn from 'classnames';
import styles from './Select.module.scss';
import messages from './messages';

type SelectProps = {
  label?: string;
  className?: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  marginTopstyle?: string
};

type SelectOption = {
  label: string;
  value: string;
  // Renders the option greyed out and unselectable. For a choice that exists
  // but isn't available to this account right now — e.g. contributor roles with
  // no free seat. The option stays VISIBLE on purpose, so the reader can see
  // what they can't pick (and why, from the copy around the field), rather than
  // wondering where it went.
  disabled?: boolean;
};

export const Select: React.FC<SelectProps> = ({ children, className, value, label, onChange, options,marginTopstyle, ...rest }) => {
  return (
    <div style={{marginTop:marginTopstyle}}>
      {label?<label htmlFor={label}>{label}</label>:''}
      <select className={cn([styles.Select, className])} value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map(({ value, label, disabled }) => (
          <option key={value} value={value} disabled={disabled}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
